import { getPortalVersion, setPortalVersion, type PortalVersion } from '@/utils/portalVersion';
import { history, useIntl } from '@umijs/max';
import { getPortalSwitchLocation } from '@/utils/releaseNavigation';
import { Segmented, Tooltip } from 'antd';
import React from 'react';

const PortalVersionSwitch: React.FC = () => {
  const intl = useIntl();
  const version = getPortalVersion();

  const handleChange = (nextVersion: string | number) => {
    const normalizedVersion: PortalVersion = nextVersion === 'v2' ? 'v2' : 'classic';
    if (normalizedVersion === version) {
      return;
    }

    setPortalVersion(normalizedVersion);
    history.replace(
      getPortalSwitchLocation(
        history.location.pathname,
        history.location.search,
        normalizedVersion,
      ),
    );
    window.location.reload();
  };

  return (
    <Tooltip title={intl.formatMessage({ id: 'component.portalVersion.tip' })}>
      <Segmented
        className={version === 'v2' ? 'portal-version-switch portal-version-switch-v2' : undefined}
        size="small"
        value={version}
        onChange={handleChange}
        options={[
          {
            label: intl.formatMessage({ id: 'component.portalVersion.classic' }),
            value: 'classic',
          },
          {
            label: intl.formatMessage({ id: 'component.portalVersion.v2' }),
            value: 'v2',
          },
        ]}
      />
    </Tooltip>
  );
};

export default PortalVersionSwitch;
